var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { withStyles } from '@mui/styles';
import React from 'react';
// @ts-ignore
import { StartRecordingDialog } from '../..';
import { openDialog } from '../../../../base/dialog/actions';
import { translate } from '../../../../base/i18n/functions';
import { IconHighlight } from '../../../../base/icons/svg';
import { MEET_FEATURES } from '../../../../base/jwt/constants';
import Label from '../../../../base/label/components/web/Label';
import { connect } from '../../../../base/redux/functions';
// @ts-ignore
import { Tooltip } from '../../../../base/tooltip';
import BaseTheme from '../../../../base/ui/components/BaseTheme.web';
// @ts-ignore
import { maybeShowPremiumFeatureDialog } from '../../../../jaas/actions';
import AbstractHighlightButton, { _abstractMapStateToProps
// @ts-ignore
 } from '../AbstractHighlightButton';
/**
 * Creates the styles for the component.
 *
 * @param {Object} theme - The current UI theme.
 *
 * @returns {Object}
 */
const styles = (theme) => {
    return {
        container: {
            position: 'relative'
        },
        disabled: {
            background: theme.palette.text02,
            margin: '0 4px 4px 4px'
        },
        regular: {
            background: theme.palette.field02,
            margin: '0 4px 4px 4px'
        },
        highlightNotification: {
            backgroundColor: theme.palette.field02,
            borderRadius: '6px',
            boxShadow: '0px 6px 20px rgba(0, 0, 0, 0.25)',
            boxSizing: 'border-box',
            color: theme.palette.uiBackground,
            fontSize: '14px',
            fontWeight: '400',
            left: '4px',
            padding: '16px',
            position: 'absolute',
            top: '32px',
            width: 320
        },
        highlightNotificationButton: {
            color: theme.palette.field01Focus,
            cursor: 'pointer',
            fontWeight: '600',
            marginTop: '8px'
        }
    };
};
/**
 * React {@code Component} responsible for displaying an action that
 * allows users to highlight a meeting moment.
 */
export class HighlightButton extends AbstractHighlightButton {
    /**
     * Initializes a new HighlightButton instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        // @ts-ignore
        this.state = {
            isNotificationOpen: false
        };
        this._onOpenDialog = this._onOpenDialog.bind(this);
        this._onWindowClickListener = this._onWindowClickListener.bind(this);
    }
    /**
     * Implements React's {@link Component#componentDidMount()}.
     *
     * @inheritdoc
     */
    componentDidMount() {
        window.addEventListener('click', this._onWindowClickListener);
    }
    /**
     * Implements React's {@link Component#componentWillUnmount()}.
     *
     * @inheritdoc
     */
    componentWillUnmount() {
        window.removeEventListener('click', this._onWindowClickListener);
    }
    /**
    * Handles clicking / pressing the start recording button.
    *
    * @returns {void}
    */
    _onOpenDialog() {
        return __awaiter(this, void 0, void 0, function* () {
            // @ts-ignore
            const { dispatch } = this.props;
            const dialogShown = yield dispatch(maybeShowPremiumFeatureDialog(MEET_FEATURES.RECORDING));
            if (!dialogShown) {
                dispatch(openDialog(StartRecordingDialog));
            }
        });
    }
    /**
    * Handles clicking / pressing the highlight button.
    *
    * @override
    * @param {Event} e - The click event.
    * @returns {void}
    */
    _onClick(e) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        // @ts-ignore
        const { _disabled } = this.props;
        if (_disabled) {
            // @ts-ignore
            this.setState({
                isNotificationOpen: true
            });
        }
        else {
            super._onClick();
        }
    }
    /**
     * Window click event listener.
     *
     * @returns {void}
     */
    _onWindowClickListener() {
        // @ts-ignore
        this.setState({
            isNotificationOpen: false
        });
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { _disabled, _visible, classes, t
        // @ts-ignore
         } = this.props;
        if (!_visible) {
            return null;
        }
        const className = _disabled ? classes.disabled : classes.regular;
        const tooltipKey = _disabled ? 'recording.highlightMomentDisabled' : 'recording.highlightMoment';
        return (React.createElement("div", { className: classes.container },
            React.createElement(Tooltip, { content: t(tooltipKey), position: 'bottom' },
                React.createElement(Label, { className: className, icon: IconHighlight, iconColor: _disabled ? BaseTheme.palette.text03 : BaseTheme.palette.field01, id: 'highlightMeetingLabel', onClick: this._onClick })),
            this.state.isNotificationOpen && (React.createElement("div", { className: classes.highlightNotification },
                t('recording.highlightMomentDisabled'),
                React.createElement("div", { className: classes.highlightNotificationButton, onClick: this._onOpenDialog }, t('localRecording.start'))))));
    }
}
// @ts-ignore
export default withStyles(styles)(translate(connect(_abstractMapStateToProps)(HighlightButton)));
